import styled from 'styled-components';

import { Color, FontWeight } from '../../theme';

export const Link = styled.a`
  color: ${Color.darkGrey};
  font-size: 16px;
  font-weight: ${FontWeight.Light};
  letter-spacing: 0;
  line-height: 20px;
  text-decoration: none;
  border-bottom: 1px solid ${Color.darkGrey};
  padding-bottom: 5px;
`;
